var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21V7l7-4 7 4v14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-4h2v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21v-4h2v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9h.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13h.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.3aaf3f441b9a1e8f7c25bc886f56d371.svg";
export { ForwardRef as ReactComponent };